import { useIntl } from 'react-intl';
import { useMediaQuery, useTheme } from '@mui/material';

import brandImage from '../../../../assets/images/brand-pages/ao1dmax-mf-30-front-new-3.png';
import brandImageMobile from '../../../../assets/images/brand-pages/ao1dmax-mf-30-front-new-mobile.png';
import clarity from '../../../../assets/images/brand-pages/clarity.svg';
import { BrandPage } from './brand-page';

export const BrandPageComfort = (): JSX.Element => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const intl = useIntl();

  return (
    <BrandPage
      title={intl.formatMessage(
        { id: 'brandPages.popularity.title' },
        {
          linebreak: <br />,
          sup: (chunks: React.ReactNode) => <sup>{chunks}</sup>,
        },
      )}
      brandImage={isMobile ? brandImageMobile : brandImage}
      topIcon={clarity}
      description={intl.formatMessage(
        { id: 'brandPages.popularity.details' },
        { sup: (chunks: React.ReactNode) => <sup>{chunks}</sup> },
      )}
      legal={intl.formatMessage(
        { id: 'brandPages.popularity.description' },
        { sup: (chunks: React.ReactNode) => <sup>{chunks}</sup> },
      )}
    />
  );
};
